import { useEffect } from 'react';
import { useLogger } from '~/common/context';
import { INTERNAL_SUPPORTED_EVENTS } from '~/common/helpers';
import { useMyCustomers } from '~/common/hooks';
import { usePurchaseContext } from '~/purchase/context';

export const useReloadCustomerListener = () => {
  const { handlers } = usePurchaseContext();
  const logger = useLogger();
  const getCustomersByUser = useMyCustomers();

  useEffect(() => {
    const handleReloadCustomers = () => {
      void getCustomersByUser.refetch().then((result) => {
        if (result.data?.data && result.data.data.length === 1) {
          const customer = result.data.data[0];
          logger.info('Reload Customers Event: Setting primary customer', {
            customerId: customer.id,
          });
          handlers.setPrimaryCustomerId(customer.id);
        }
      });
    };

    window.addEventListener(
      INTERNAL_SUPPORTED_EVENTS.RELOAD_CUSTOMER,
      handleReloadCustomers,
    );

    return () => {
      window.removeEventListener(
        INTERNAL_SUPPORTED_EVENTS.RELOAD_CUSTOMER,
        handleReloadCustomers,
      );
    };
  }, [getCustomersByUser, handlers, logger]);
};
